import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ContentTypes} from "../../../services/db/config/content-types";
import {DbKeys} from "../../../services/db/config/db-config";
import {FileService} from "../../../services/file/file.service";
import {DatabaseService} from "../../../services/db/database.service";
import {BasicResource} from "../../../models/ressources/basic-resource";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-create-exercice',
  templateUrl: './create-exercice.component.html',
  styleUrls: ['./create-exercice.component.scss']
})
export class CreateExerciceComponent implements OnInit {
  protected exerciceForm: FormGroup;
  protected canSubmit: boolean;
  protected contentType: string;
  private readonly exercicePath: DbKeys;

  constructor(
    private readonly fb: FormBuilder,
    private readonly db: DatabaseService,
    private readonly fileService: FileService,
    private readonly snackbar: MatSnackBar,
    private readonly dialogRef: MatDialogRef<CreateExerciceComponent>
  ) {
    this.canSubmit = true;
    this.contentType = ContentTypes.pdf;
    this.exercicePath = DbKeys.exercices;
  }

  ngOnInit(): void {
    this.exerciceForm = this.fb.group({
      name: ['', Validators.required],
      file: [undefined, Validators.required],
    })
  }

  get name() {
    return this.exerciceForm.get('name') as FormControl;
  }

  get file() {
    return this.exerciceForm.get('file') as FormControl;
  }

  protected async onSubmit() {
    if (this.canSubmit && this.exerciceForm.valid) {
      this.canSubmit = false;
      const {name, file} = this.getFormParams();

      try {
        const url = await this.storeFile(file, this.exercicePath);
        const id = await this.storeFileRef(name, url, this.exercicePath);
        this.dialogRef.close(new BasicResource(id, url, name))
      } catch (e) {
        this.displayError(e);
      } finally {
        this.snackbar.open(`${name} ajouté !`, 'OK', {duration: 5000});
      }
    }
  }

  private getFormParams() {
    return {name: this.name.value, file: this.file.value}
  }

  private async storeFile(file: File, path: string) {

    if (!file) throw new EmptyFileError();

    try {
      const upload = await this.fileService.uploadFile(file, path, ContentTypes.pdf);
      return await upload.ref.getDownloadURL();
    } catch (e) {
      throw new FileUploadError();
    }
  }

  private async storeFileRef(name: string, url: string, path: string): Promise<string> {
    if (!url) throw new EmptyUrlError();

    try {
      const ref = await this.db.addData({url, name}, path);
      return ref.id
    } catch (e) {
      throw new FileStorageError();
    }
  }


  onFileChange({target}: Event) {
    const files = (target instanceof HTMLInputElement) ? target.files : [];
    const file = files?.[0];

    if (file) {
      this.exerciceForm.patchValue({file: file})
    }
  }

  private displayError(e: any) {
    if (e instanceof Error) this.snackbar.open(`Erreur : ${e.message}`)
    else this.snackbar.open(`Erreur inconnue : ${e}`)
  }
}

class EmptyFileError extends Error {
  constructor() {
    super('Le fichier n\'est pas défini');
  }
}

class FileUploadError extends Error {
  constructor() {
    super('Erreur lors de l\'upload du fichier.');
  }
}


class EmptyUrlError extends Error {
  constructor() {
    super('L\'url est vide');
  }
}

class FileStorageError extends Error {
  constructor() {
    super('Erreur en base de données lors du stockage de l\'url.');
  }
}

